import Radio from './radio.vue';

export default Radio;


// WEBPACK FOOTER //
// ./src/components/inputs/radio/index.js